import React from 'react';
import { Stack, Typography, styled } from '@mui/material';

const TitleWallet = styled(Stack)(({ theme }) => ({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  height: 'auto',
  width: '100%',
  maxWidth: '100%',
  [theme.breakpoints.up('lg')]: {
    marginTop: '8px',
  },
  [theme.breakpoints.down('md')]: {
    marginTop: '20px',
  },
}));

const ImageContent = styled(Stack)(({ theme }) => ({
  position: 'relative',
  isolation: 'isolate',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  padding: '0px',
  boxSizing: 'border-box',
  marginTop: '0px',
  [theme.breakpoints.up('lg')]: {
    marginTop: '8px',
  },
}));

const WalletSummaryContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}));

const IconsNotification = styled('img')({
  height: '25px',
  width: '25px',
  backgroundColor: '#3B82f6',
  borderRadius: '100%',
  padding: '5px',
});

const TitleAmount = styled(Typography)({
  textAlign: 'center',
  whiteSpace: 'pre-wrap',
  fontWeight: '400',
  letterSpacing: '-0.04px',
  textDecoration: 'none',
  textTransform: 'none',
  alignSelf: 'stretch',
  margin: '0px',
});

const WalletNoAmountCard = ({ handleRedirect }) => {
  return (
    <>
      <WalletSummaryContainer>
        <TitleWallet>
          <ImageContent>
            <IconsNotification
              src='/assets/images/dashboard/iconNotification.svg'
              alt='Notification'
            />
          </ImageContent>

          <TitleAmount fontSize={'clamp(12px, 2vw, 14px)'}>
            ¡Carga tu caja para invertir!
          </TitleAmount>
        </TitleWallet>
      </WalletSummaryContainer>
    </>
  );
};

export default WalletNoAmountCard;
